module.exports = __webpack_public_path__ + "assets/img/en-05c6857f.png";